import { useParams } from 'react-router-dom';

import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import useFetchSessionStats from './use-fetch-session-stats';
import StatsCard from '../components/stats-card';
import IconResendEmailGradient from '@ui/icons/gradient-icons/icon-resend-email-gradient';
import IconFilterAltGradient from '@ui/icons/gradient-icons/icon-filter-alt-gradient';
import IconRegistrationOutlinelGradient from '@ui/icons/gradient-icons/icon-registration-outline-gradient';
import IconSendGradient from '@ui/icons/gradient-icons/icon-send-gradient';
import IconTouchAppGradient from '@ui/icons/gradient-icons/icon-touch-app-gradient';
import Link from '@ui/links/link';
import ViewStatsContent from '../components/view-stats-content';
import useGetStatsIconColors from '../helpers/use-get-stats-icon-colors';
import { EPermissions } from '@/types/permissions.types';
import AuthWrapper from '@ui/auth-wrapper/auth-wrapper';

type SessionStatsRowProps = {
  sessionUuid?: string;
  projectUuid?: string;
  isPublished?: boolean;
};

const SessionStatsRow = ({ projectUuid, isPublished, sessionUuid }: SessionStatsRowProps) => {
  const params = useParams();
  const language = params?.language || 'en';

  const { loading, data } = useFetchSessionStats({
    projectUuid,
    sessionUuid,
    disabled: !isPublished,
    language,
  });

  const statsColors = useGetStatsIconColors();

  /* 
    TODO:
    Update stats to follow the stats used in figma for each session type.
    https://www.figma.com/design/xq2Pwf0fOxO0vp1AC2vpLD/Platform-%E2%80%A2-Feature---Updates--2?node-id=1020-21164&p=f&m=dev
  */
  return (
    <div className="flex-column gap-8 margin-t-24 padding-h-10" data-component="SessionStatsRow">
      <div className="flex ai-flex-end jc-space-between">
        <Text className="H5">Stats</Text>
        <div>
          <Container>
            <AuthWrapper allowedRoles={[EPermissions.GroupAdmin]}>
              <Link
                to={`/project/edit/${projectUuid}/${language}/stats/session/${sessionUuid}`}
                textColor="none"
                focusBackgroundColor="rgba(var(--gray-700-rgb), 0.5)"
                applyFocusStatesToAllChildren
                hoverOpacity={0.8}
              >
                <ViewStatsContent />
              </Link>
            </AuthWrapper>
          </Container>
        </div>
      </div>

      <Container className="flex fd-row jc-space-evenly ai-center gap-8">
        <StatsCard
          loading={isPublished ? loading : false}
          title="Invited"
          tooltip="TODO: Actual numbers not available yet"
          value={isPublished ? (data.registrations?.value ?? -1) : -1}
          Icon={<IconResendEmailGradient from={statsColors.from} to={statsColors.to} />}
        />
        <StatsCard
          loading={isPublished ? loading : false}
          title="Registered"
          tooltip="TODO: Actual numbers not available yet"
          value={isPublished ? (data.registrations?.value ?? -1) : -1}
          Icon={<IconRegistrationOutlinelGradient from={statsColors.from} to={statsColors.to} />}
        />
        <StatsCard
          loading={isPublished ? loading : false}
          title="Conversation rate"
          tooltip="TODO: Actual numbers not available yet"
          value={isPublished ? (data.registrations?.value ?? -1) : -1}
          Icon={<IconFilterAltGradient from={statsColors.from} to={statsColors.to} />}
        />
        <StatsCard
          loading={isPublished ? loading : false}
          title="Interactions"
          tooltip="TODO: Actual numbers not available yet"
          value={isPublished ? (data.registrations?.value ?? -1) : -1}
          Icon={<IconTouchAppGradient from={statsColors.from} to={statsColors.to} />}
        />
        <StatsCard
          loading={isPublished ? loading : false}
          title="Shares"
          tooltip="TODO: Actual numbers not available yet"
          value={isPublished ? (data.registrations?.value ?? -1) : -1}
          Icon={<IconSendGradient from={statsColors.from} to={statsColors.to} />}
        />
      </Container>
    </div>
  );
};

export default SessionStatsRow;
